import {
  computed,
  ref,
  toRef,
} from "vue";

import {
  isUndefined,
  max,
  min,
} from "lodash-es";

export default function OffsetLimitAPI(props, {
  limitLocal = ref(0),
  offsetLocal = ref(0),
  reloadData = () => {},
  saveTableOptions = () => {},
  viewCurrent = ref(undefined),
}) {
  const isPaginationOutside = toRef(props, "isPaginationOutside");
  const url = toRef(props, "url");
  const usePagination = toRef(props, "usePagination");

  const usePaginationLocal = computed(() => {
    if (usePagination.value) {
      if (viewCurrent.value) {
        return viewCurrent.value.usePagination || false;
      }
      return true;
    }
    return false;
  });

  const isPaginationOutsideLocal = computed(() => {
    if (!url.value || isPaginationOutside.value === false) {
      return false;
    }
    return isPaginationOutside.value;
  });

  const initPaginationFromUrl = ({ urlParams }) => {
    if (!isUndefined(urlParams.limit)) {
      limitLocal.value = min([max([1, +urlParams.limit]), 100]);
    }
    if (!isUndefined(urlParams.offset)) {
      offsetLocal.value = urlParams.offset;
    }
  };

  const changeOffset = ({ offset }) => {
    offsetLocal.value = offset;
    if (isPaginationOutsideLocal.value) {
      reloadData();
    }
  };

  const changeLimit = ({ offset, limit }) => {
    limitLocal.value = limit;
    offsetLocal.value = offset;
    if (isPaginationOutsideLocal.value) {
      reloadData();
    }
    saveTableOptions();
  };

  return {
    changeLimit,
    changeOffset,
    initPaginationFromUrl,
    isPaginationOutsideLocal,
    usePaginationLocal,
  };
}
